import React from 'react'
import {findDOMNode} from 'react-dom'
import NavigationMenu_ProjectsLocalSettings from "../../local-settings"
import NavigationMenu_ProjectsTree from "./tree/projects-tree"
import {BUS_TREE_CHANGE, SESSION_STARRED_CHANGED} from "../../../../core/gd/bus/bus-event-type"
import NavigationMenu_StarredProjects from "../../components/starred/starred-projects"

export default class NavigationMenu_ProjectsCustomer extends React.Component<any> {

    private animationDelay  : any
    private animShow        : boolean = false

    public localSettings : NavigationMenu_ProjectsLocalSettings
    public companyUpdating? : boolean

    constructor(props:any) {
        super(props);

        this.localSettings = new NavigationMenu_ProjectsLocalSettings()
    }

    componentDidMount() {
        gd.bus.subscribe(BUS_TREE_CHANGE, this, this.sessionDataChanged);

        // need it on this level as we separate stars and all projects
        gd.bus.subscribe(SESSION_STARRED_CHANGED, this, this.sessionDataChanged)

        this.animationDelay = _.delay(()=>{
            this.animShow = true
            const dom = findDOMNode(this);
            gd.utils.Dom.addClass(dom, 'anim-show');
        }, 50);
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)
        gd.bus.unsubscribe(this)
    }

    sessionDataChanged = () => {
        this.setState({ reRender: true })
    }

    preventClosePopover() {
        const res = this.companyUpdating;
        this.companyUpdating = false;
        return res;
    }

    render() {
        // const starredProjectsIds    = gd.session.starredItems.getProjectsIds()
        // const rootItems             = ProjectsListManager.getChildProjects(gd.companyId, null, 'name', true);

        // const rootProjects = _.filter(rootItems, project=>
        //     project.systemType !== gd.const.project.systemType.TAG &&
        //     (!starredProjectsIds || !starredProjectsIds.includes(project.id)));

        // const rootTags = _.filter(rootItems, (item:any)=> {
        //     const project = gd.session.projects.get(item.id)!
        //     return project.isTag && !project.isDeleted
        // }) as unknown as TypeProjectListItem[]

        const classes = Classes("main-menu-container p-t-10 ui5-menu menu-projects", {
            'animation'     : gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show'     : this.animShow
        })

        return (
            <div className={classes}>

                {/*<NavigationMenu_TopHeader title="Projects" >*/}
                    {/*<SortButton value    = {this.localSettings.sortType}*/}
                    {/*            className= "m-r-5"*/}
                    {/*            onChange = {this.onSortTypeChange}*/}
                    {/*            onReset  = {this.onSortDefaultReset}/>*/}
                {/*</NavigationMenu_TopHeader>*/}

                {/*<NavigationMenu_ProjectsStarred />*/}
                <NavigationMenu_StarredProjects space={gd.spaces.projects} />

                <NavigationMenu_ProjectsTree showAdd         = {false}
                                             space           = {gd.spaces.projects}
                                             localSettings   = {this.localSettings}/>

                {/*{rootTags?.length>0 &&*/}
                {/*    <NavigationMenu_ProjectsTags showAdd = {false}*/}
                {/*                                 tags    = {rootTags}/>*/}
                {/*}*/}

            </div>
        );
    }
}
